import React, { useCallback, useLayoutEffect, useState, useMemo } from "react"
import useCheckPermission from "utils/auth/useCheckPermission"

import {
  Link,
  Route,
  Switch,
  useHistory,
  useRouteMatch,
} from "react-router-dom"
import ApiReceiptOfInvoice from "services/api-receipt-of-invoice"
import { ROUTE_RECEIPT_OF_INVOICE } from "constants/routeConstants"
import PERMISSION_CODES from "constants/permission-codes"
import RouteBreadcrumb from "components/page-layout/breadcrumbs/RouteBreadcrumb"
import useShowSnackbar from "utils/snackbar-hooks"
import { Button } from "@material-ui/core"
import ROIItemDisplay from "components/receipt-of-invoice/ROIItemDisplay"
import ROIDeleteDialog from "components/receipt-of-invoice/ROIDeleteDialog"
import ReceiptOfInvoiceUpdatePage from "./ReceiptOfInvoiceupdatePage"

export default function ReceiptOfInvoiceItemPage() {
  const { checkWithoutUpdateState } = useCheckPermission()
  const [showSnackbar] = useShowSnackbar()

  const [item, setItem] = useState(null)
  const [fetchingInitData, setFetchingInitData] = useState(false)
  const [itemExist, setItemExist] = useState(false)
  const [flagRefetch, setFlagRefetch] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)

  const history = useHistory()
  const routeMatch = useRouteMatch()
  const id = routeMatch?.params?.id

  const loading = fetchingInitData

  const fetchInitialData = useCallback(
    async (itemId, checkActive) => {
      setFetchingInitData(true)

      let tempItemExists = true
      let tempItem = null

      try {
        const { data: responseData } = await ApiReceiptOfInvoice.getItem(itemId)

        if (!checkActive()) return

        if (!responseData) {
          tempItemExists = false
        } else {
          tempItem = responseData
        }

        setItemExist(tempItemExists)
        setItem(tempItem)
      } catch (err) {
        if (checkActive()) {
          setItemExist(false)
          showSnackbar("Failed to fetch Receipt of Invoice data")
        }
      } finally {
        if (checkActive()) {
          setFetchingInitData(false)
        }
      }
    },
    [showSnackbar]
  )

  const handleClosed = async ({ confirm }) => {
    setOpenDialog(false)
    if (confirm) {
      await ApiReceiptOfInvoice.delete(item.idReceiptOfInvoice)
      showSnackbar("Receipt of Invoice deleted successfully")
      history.push(`${ROUTE_RECEIPT_OF_INVOICE}`)
    }
  }

  // useLayoutEffect(() => {
  //   if (!id) return

  //   let active = true
  //   const checkActive = () => active

  //   fetchInitialData(id, checkActive)

  //   return () => {
  //     active = false
  //   }
  // }, [id, fetchInitialData, flagRefetch])

  useLayoutEffect(() => {
    let active = true
    const checkActive = () => active

    if (id) {
      fetchInitialData(id, checkActive)
    }

    return () => {
      active = false
    }
  }, [id, fetchInitialData, flagRefetch])

  const ITEM_ROUTE = `${ROUTE_RECEIPT_OF_INVOICE}/${id}`
  const EDIT_ROUTE = `${ROUTE_RECEIPT_OF_INVOICE}/${id}/edit`

  // --- Permission handling (sesuaikan dengan nama permission di project-mu) ---
  const canEdit = useMemo(
    () =>
      checkWithoutUpdateState(PERMISSION_CODES.RECEIPT_OF_INVOICE_EDIT || ""),
    [checkWithoutUpdateState]
  )

  const canDelete = useMemo(
    () =>
      checkWithoutUpdateState(PERMISSION_CODES.RECEIPT_OF_INVOICE_DELETE || ""),
    [checkWithoutUpdateState]
  )

  const canCreateROI = useMemo(
    () =>
      checkWithoutUpdateState(PERMISSION_CODES.RECEIPT_OF_INVOICE_CREATE || ""),
    [checkWithoutUpdateState]
  )

  const showEditAndDelete = canEdit || canDelete

  // --- Handlers ---

  const handleEdit = () => {
    history.push(EDIT_ROUTE)
  }

  const handleCreateROI = () => {
    history.push(`${ROUTE_RECEIPT_OF_INVOICE}/create`)
  }

  const notFoundDisplay = (
    <div>
      Receipt of Invoice data not found.
      <Button
        component={Link}
        style={{ display: "block", margin: "auto", width: "100px" }}
        to={ROUTE_RECEIPT_OF_INVOICE}
        variant="contained"
        disableElevation
        color="primary"
      >
        Back
      </Button>
    </div>
  )

  const mainContent = (
    <>
      <Switch>
        <RouteBreadcrumb name="Edit Receipt of Invoice" path={EDIT_ROUTE}>
          <ReceiptOfInvoiceUpdatePage
            id={id}
            formData={item}
            setFormData={setItem}
            onSuccess={() => setFlagRefetch((prev) => !prev)}
          />
        </RouteBreadcrumb>

        <Route exact path={ITEM_ROUTE}>
          {item ? (
            <ROIItemDisplay
              data={item}
              showEditAndDelete={showEditAndDelete}
              onConfirmEdit={canEdit ? handleEdit : () => {}}
              // onConfirmDelete={canDelete ? handleDelete : () => {}}
              onConfirmDelete={() => setOpenDialog(true)}
              canCreateROI={canCreateROI}
              onConfirmCreateROI={handleCreateROI}
            />
          ) : (
            notFoundDisplay
          )}
        </Route>
      </Switch>
      <ROIDeleteDialog
        open={openDialog}
        onClose={handleClosed}
        woNumber={item?.woNumber}
      />
    </>
  )

  if (loading) {
    return <>Loading...</>
  }

  return itemExist ? mainContent : notFoundDisplay
}
